export default __webpack_public_path__ + "0562474.png";